const reviewsUtil = {
  get: () => {
    return new Promise((resolve, reject) => {
      let domain = '';
      window.location.href.includes('gocart-stg') ? domain = 'gocart-stg.myshopify.com' : domain = 'wego-gocart-online.myshopify.com';

      let reviewsResponse;
      let reviewsData;

      $.ajax({
        url: 'https://stamped.io/api/widget/reviews',
        method: 'GET',
        dataType: 'json',
        async: true,
        data: {
          productId: $('#data').data('id'),
          storeUrl: domain,
          apiKey: WEGO.keyPublic,
          take:2
        }
      }).done(function (reviews) {
        reviewsResponse = reviews;
        const reviewsDataResponse = reviews.data;
        reviewsData = reviewsDataResponse;
        resolve({ reviewsResponse, reviewsData });
      }).fail(function (error) {
        console.error('Get Review Error:', error);
        reject(error);
      });
    });
  }
}; 